import React, { useEffect, useState } from "react";
import Breadcrumb from "component/common/breadcrumb";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import { handleListResponse, seo } from "utils/utils";
import usePage from "utils/usePage";
import moment from "moment";
import TableDataNotFound from "component/TableDataNotFound";
import Pagination from "component/common/Pagination";
import { getUserActivityReport } from "../../reduxStore/action/reportActions";

const UserActivityReport = () => {
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [userActivityReport, setUserActivityReport] = useState([]);
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    user_id: "",
    module_name: "",
  });
  const userActivityReportSelector = useSelector((state) => state?.report);
  useEffect(() => {
    if (userActivityReportSelector?.userActivityReport?.status === 200) {
      if (
        userActivityReportSelector?.userActivityReport?.data?.length >
        0
      ) {
        setUserActivityReport(
          handleListResponse(userActivityReportSelector?.userActivityReport?.data)
        );
      }
    } else {
      setUserActivityReport([]);
    }
  }, [userActivityReportSelector]);

  useEffect(() => {
    dispatch(getUserActivityReport({ limit: 10, offset: page }));
  }, [dispatch]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getUserActivityReport({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          user_id: form.user_id,
          module_name: form.module_name,
        })
      );
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      module_name: "",
      user_id: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    dispatch(getUserActivityReport({ limit: 10, offset: 0 }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      getUserActivityReport({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        module_name: form.module_name,
        user_id: form.user_id,
      })
    );
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Report Management",
      metaDescription: "Report management",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.report}
        titleactive={strings.UserActivityList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByUserName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="user_id"
                              placeholder="Search User Name"
                              value={form.user_id}
                              onChange={handleInputField}
                              min={form.start_date}
                              max={form.user_id}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByModuleName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="module_name"
                              placeholder="Search Module Name"
                              value={form.module_name}
                              onChange={handleInputField}
                            />
                          </div>
                        </div>
                        <div className="col-md-8 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.UserActivityList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.userName}</th>
                          <th scope="col">{strings.role}</th>
                          <th scope="col">{strings.access}</th>
                          <th scope="col">{strings.date}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {userActivityReport?.length > 0 ? (
                          userActivityReport.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.user_name}</td>
                                <td>{item.user_role}</td>
                                <td>{item.module_name}</td>
                                <td>
                                  {/* {moment(item.createdDate).format(
                                    "DD-MM-yyyy hh:mm a"
                                  )} */}
                                  {moment.utc(item.createdDate).format("DD-MM-YYYY hh:mm a")}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={userActivityReport} />
                  </div>
                  <Pagination
                    totalCount={
                      userActivityReportSelector?.response?.total_data
                    }
                    listData={userActivityReport}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserActivityReport;
